import classnames from "classnames"
import PropTypes from "prop-types"
import PathwrightUI from "../ui/PathwrightUI"
import { objectifyRgba, parseRgba } from "../utils/colors"
import "./LoadingCircle.css"

const LoadingCircle = ({
  size = 25,
  inverted,
  center = true,
  color,
  brand,
  ...rest
}) => {
  const className = classnames(
    "LoadingCircle",
    {
      "LoadingCircle--center": center,
      "LoadingCircle--inverted": inverted
    },
    rest.className
  )

  return (
    <PathwrightUI.Consumer>
      {({ primaryBrandColor }) => {
        const rgba = objectifyRgba(
          inverted
            ? "255,255,255"
            : color
            ? color
            : brand
            ? primaryBrandColor
            : "150,150,150"
        )

        const alpha = rgba.a || 0.9

        const styles = {
          minWidth: size,
          minHeight: size,
          maxWidth: size,
          maxHeight: size,
          border: `2px solid ${parseRgba({
            ...rgba,
            a: alpha
          })}`,
          borderRightColor: parseRgba({
            ...rgba,
            a: alpha / 2
          }),
          top: center ? `calc(50% - ${size / 2}px)` : "auto",
          ...rest.style
        }
        return <div className={className} style={styles} />
      }}
    </PathwrightUI.Consumer>
  )
}

LoadingCircle.displayName = "LoadingCircle"

LoadingCircle.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  inverted: PropTypes.bool,
  center: PropTypes.bool,
  brand: PropTypes.bool
}

export default LoadingCircle
